export const css = {
	root: '_24cb8X1U',
	resourcelink: '_2FmGXSsC',
	externallink: '_3uvSErCD',
	resourcepara: '_3Aq3qFiM',
	resourcediv: '_2S-U0crN',
	videolink: '_2jOnZRjy',
	rcslink: '_1Qqg0xw4',
	certlink: '_35hi6wch',
	evallink: '_1W0ovk27',
	cialink: '_3eJRuDu2',
	head1: 'RI-FElfR',
	head2: '_3L1-ZPj_',
	head3: '_1E_UoTV8',
	icon: 'k_CReaFA',
	image: '_1N72xjz2',
	' _key': 'resource-parser/resource-parser'
};

export default css;
